import { deleteApi, get, post } from "../GenericServices";

const FuelCard = {
  getFuelCards: (queryString) => {
    return get(`fuel-card${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getFuelCard: (id) => {
    return get(`fuel-card/${id}`);
  },
  setFuelCard: (data) => {
    return post(`fuel-card`, data);
  },
  deleteFuelCard: (id) => {
    return deleteApi(`fuel-card/${id}`);
  },
  downloadExportFile: () => {
    return get(`fuel-card/export`);
  },
};

export default FuelCard;
